import { SearchWorkspace } from '../components/search/search-workspace'

export function SearchPage() {
  return <SearchWorkspace />
}
